<!-- Revised on 2025/10/16 by mnavarro -->
<template>
  <div class="dropdown d-inline">
    <Button id="orderbackOutboxActionFilter" color="primary" :title="$t('key_filter_action')" class="dropdown-toggle " :variant="actionSelected == '' ? 'outline' : 'fill'"
      data-bs-toggle="dropdown" aria-expanded="false">
      <i class="fa-solid fa-flag me-1" aria-hidden="true"></i>
    </Button>
    <ul class="dropdown-menu dropdown-menu-lg-start px-2 py-3" aria-labelledby="orderbackOutboxActionFilter">
      <li>
        <button class="dropdown-item border-radius-md text-actionpost" :class="[filterActionSelected=='POST'?'active-item':'']" type="button" @click="handleClick('POST')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-p me-3 text-actionpost"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_filter_action_post') }}</span>
        </button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-actiondelete" :class="[filterActionSelected=='DELETE'?'active-item':'']" type="button" @click="handleClick('DELETE')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-d me-3 text-actiondelete"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_filter_action_delete') }}</span>
        </button>
      </li>
      <li>
        <hr class="horizontal dark my-2" />
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-clearfilter" type="button" @click="handleClick('')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-eraser me-3 text-clearfilter"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_filter_clear_filters') }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>

  import Button from "./../../../../../generic_components/Button.vue";

  export default {
    name:"OrderBackOutboxQueueActionFilter",
    components: {
      Button
    },
    props: {
      filterActionSelected: {
        type: String,
        default: () => ''
      }
    },
    emits: ['orderback-outbox-queue-action-filter-change'],
    data() {
      return {
        actionSelected: ''
      }
    },
    watch: {
      filterActionSelected() {
        this.actionSelected = this.filterActionSelected;
      }
    },
    methods: {
      handleClick(action) {
        this.actionSelected = action;
        this.$emit('orderback-outbox-queue-action-filter-change', action);

        const dropdownElement = document.querySelector('.dropdown-menu.show');
        if (dropdownElement) {
          dropdownElement.classList.remove('show');
        }
      }
    }
  }

</script>
